import { DataGridProProps } from '@mui/x-data-grid-pro';
import { t } from 'i18next';
import { PrefilledDataConfig } from '../../../common/controllers/PaginatedTableController';
import { SshHandshakesTableController } from '../../../common/handshakes/controllers/SshHandshakesTableController';
import { SshHandshake } from '../../../common/handshakes/models/SshHandshake';
import { DefaultHeaderConfiguration } from '../../../common/types/paginated-table';
import { PaginationResult } from '../../../common/types/pagination';

type Props = {
  operationId: number;
  initialData: PaginationResult<SshHandshake> | null;
  parentLoading: boolean;
};

export class OperationSshHandshakesTable extends SshHandshakesTableController<Props> {
  protected isLoading(): boolean {
    return super.isLoading() || this.props.parentLoading;
  }

  protected enableSorting(): boolean {
    return false;
  }

  protected getDefaultPageSize(): number {
    return 1;
  }

  protected getPageSizeOptions(): number[] {
    return [1];
  }

  protected getPrefilledConfig() {
    return {
      prefillActive: true,
      initialLoading: this.props.parentLoading,
      initialData: this.props.initialData,
    } as PrefilledDataConfig<SshHandshake>;
  }

  protected getDefaultHeaderConfigurations(): DefaultHeaderConfiguration {
    return { title: t('handshakes.sshHandshake'), hideRowCount: true };
  }

  protected getAdditionalDataGridProps(): Partial<DataGridProProps<SshHandshake>> {
    return {
      ...super.getAdditionalDataGridProps(),
      hideFooter: true,
    };
  }
}
